import React, { useState } from "react";
import Wizard from "./Wizard/Wizard.component";
import { shouldAdvanceEpoch } from "./CreateCalculationPanel.constants";
import type { CreateCalculationPanelProps } from "./CreateCalculationPanel.types";

// Bump the child form key before it can render stale open-state values.
const CreateCalculationPanel: React.FC<CreateCalculationPanelProps> = ({
  active,
  onClose,
  onSuccess,
}) => {
  const [epoch, setEpoch] = useState(0);
  const [wasActive, setWasActive] = useState(active);
  if (active !== wasActive) {
    setWasActive(active);
    if (shouldAdvanceEpoch(wasActive, active)) setEpoch((e) => e + 1);
  }

  return (
    <Wizard
      key={epoch}
      active={active}
      onClose={onClose}
      onSuccess={onSuccess}
    />
  );
};

export default React.memo(CreateCalculationPanel);
